
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 15 15"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M13.461 10.308l.008-.006c-.017-.021-1.673-2.192-2.244-5.395a3.744 3.744 0 00-2.268-3v-.459C8.957.67 8.324.036 7.545.036c-.778 0-1.411.633-1.411 1.412v.458c-1.206.509-2.102 1.623-2.264 2.973-.572 3.217-2.231 5.401-2.248 5.423l.007.006a1.81 1.81 0 00-.339 1.062c0 .93.67 1.689 1.5 1.689h2.96c-.01.03-.01.07-.01.101v.06c.03.971.83 1.74 1.81 1.74a1.8 1.8 0 001.8-1.74v-.06c0-.03 0-.07-.01-.101h2.96c.83 0 1.5-.76 1.5-1.689 0-.406-.13-.772-.339-1.062zm-6.577-8.86a.662.662 0 111.323 0v.232a3.797 3.797 0 00-.616-.071v-.001h-.092v.001a3.69 3.69 0 00-.615.072v-.233zM4.858 5.026a2.752 2.752 0 012.687-2.417 2.758 2.758 0 012.691 2.445 14.893 14.893 0 001.661 4.625H3.193a14.942 14.942 0 001.665-4.653zM8.6 13.19a1.05 1.05 0 01-1.05 1.02c-.58 0-1.04-.45-1.06-1.02 0-.04.01-.091.02-.131h2.08c0 .041.01.081.01.131zm3.7-1.13H2.79c-.27 0-.5-.319-.5-.689 0-.38.23-.69.5-.69h9.51c.271 0 .5.311.5.69 0 .369-.23.689-.5.689z"}})])
          )
        }
      }
    